import { ReactNode, useLayoutEffect, useRef, useState } from 'react';

import { EventEmitter, eventTypes, events } from '../../app/event-emitter';
import { SidebarControl } from '../../controls/sideBarControl/side-bar-control';
import { Sidebar, SidebarTitle } from '../sidebar';

import styles from './configurator-layout.module.css';
import { RotatingLines } from 'react-loader-spinner';

export const cfgLayoutStyles = {
    overlayHeader: styles.overlayHeader,
    overlayDebug: styles.overlayDebug
}

export function ConfiguratorLayout({ sidebarTitle, sidebarSteps, sidebarContent, 
                                     overlayContent, overlayFooter,
                                     loading, children }: {
    sidebarTitle?: string
    sidebarSteps?: string
    sidebarContent?: ReactNode
    overlayContent?: ReactNode
    overlayFooter?: ReactNode
    loading?: boolean
    children?: ReactNode
}) {

    const rootRef = useRef<HTMLDivElement>(null);
    const overlayRef = useRef<HTMLDivElement>(null);

    const [ isOpenSideBar, setIsOpenSideBar ] = useState(true);


    const handleArrow = () => {
        setIsOpenSideBar(!isOpenSideBar)
    }

    useLayoutEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            const overlayNode = overlayRef.current;
            const rootNode = rootRef.current;
            if(overlayNode && rootNode) {
                const overlayRect = overlayNode.getBoundingClientRect();
                const rootRect = rootNode.getBoundingClientRect();
                const overlayCenterX = (overlayRect.left - rootRect.left) + (overlayRect.width / 2);
                const offsetXPx = overlayCenterX - (rootRect.width / 2);
                const offsetXPct = offsetXPx / rootRect.width;
                EventEmitter.dispatch(eventTypes.DOM_EVENTS, events.VIEW_OFFSET_EVENT, offsetXPct);
            }
        });

        resizeObserver.observe(overlayRef.current!, { box: 'border-box' });

        return () => {
            resizeObserver.disconnect();
        }   

    }, [])

    return <div ref={rootRef} className={styles.cfgRoot} role="presentation">
        <div ref={overlayRef} className={`${styles.overlay} ${isOpenSideBar ? '' : styles.bigOverlay}`}>
            <div className={`${styles.loadingArea} ${loading ? styles.loading : ''}`}>
                <RotatingLines strokeColor='grey' width='48'/>
            </div>
            { overlayContent }
            <div className={styles.overlayFooter} role="presentation">
                { overlayFooter }
            </div>
        </div>
        <div className={styles.sidebarArea}>
            <SidebarTitle className={`${styles.sidebarTitle} ${!isOpenSideBar?styles.hidden:""}`} 
                          title={ sidebarTitle ?? '' } steps={ sidebarSteps }/>
            <Sidebar className={`${styles.sidebarContent} ${!isOpenSideBar?styles.hidden:""}`} >                
                { sidebarContent }
            </Sidebar>
            <SidebarControl onHandleArrow={handleArrow} arrowLeft={isOpenSideBar}/>
        </div>
        {children}
    </div>
}